/**
 * Coordinates used as the center of the map (if the user's location is not available).
 */
export const DEFAULT_CENTER = {
  latitude: 38.5,
  longitude: -96, // less negative moves East, more negative moves West
};

/**
 * The distance from the centre point to make visible in the map view; effectively sets the initial zoom level.
 */
export const DEFAULT_DELTA = {
  latitudeDelta: 62,
  longitudeDelta: 62,
  // Larger deltas if the user is not known show more of the continental US (at the time of writing it is set
  // primarily to capture Colorado and New York, the two regions where we have the most presence).
};

export default function pantryRegionForUser(user) {
  return {
    latitude: user?.latitude || DEFAULT_CENTER.latitude,
    longitude: user?.longitude || DEFAULT_CENTER.longitude,
    ...DEFAULT_DELTA,
  };
}
